import '../actions';

import { createReducer } from '@reduxjs/toolkit';

export default createReducer({}, {});
